import React, { useEffect } from "react";

//use browser history
import { useHistory } from "react-router-dom";

// Styling
import "../../Styles/MainPage.scss";

const UpdateWeaviatePage = () => {
  //to use history
  const history = useHistory();

  //self hosted Weaviate version
  const version = JSON.parse(localStorage.getItem("selfHostedWeaviateVersion"));

  // Console logo SVG format
  const logo =
    "https://weaviate.io/img/site/weaviate-nav-logo-light.svg";

  useEffect(() => {
    history.push(`/update-weaviate-version`);

    window.scrollTo(0, 0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="__UpdateWeaviatePage">
      <img
        src={logo}
        alt="Logo"
        onClick={() => window.location.reload()}
      />
      <div className="__message">
        <h1>
          The Weaviate instance you're trying to connect is running on version{" "}
          <strong
            id="selfHostedWeaviateOldVersion"
            className="__selfHostedVersion"
          >
            {version}
          </strong>
          . The Console supports Weaviate versions 1.0.0 or higher. Please
          update your Weaviate instance to use the Console.
        </h1>
        <p>
          Click{" "}
          <a id="backToLandingPageLink" href={`${window.origin}`}>
            here
          </a>{" "}
          to connect to a different self-hosted Weaviate instance or to
          login/register to Weaviate Cloud Service service. <br />
          Click{" "}
          <a href="https://www.weaviate.io">
            here
          </a>{" "}
          to learn more about our Weaviate Cloud Service.
        </p>
      </div>
    </div>
  );
};

export default UpdateWeaviatePage;
